<div class="cald_dialog" #multilistboxTableDialog>
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="close()">&#xe03e;</button>
    @if (data.title) {
      <h2>{{data.title | translate}}</h2>
    }
    @if (!data.title && data.productName) {
      <h2>{{'Admin.CategoryTreeView.TitleFor' | translate}}
      {{data.productName}}</h2>
    }
    @if (!data.title && !data.productName) {
      <h2>{{(data.isMultiSelect ? 'AddCategory.Title1' :
      'Admin.cattree.Title') | translate}}</h2>
    }
  </div>
  <div class="cald_content">
    <div class="cpq-dialog-content-scroll">
      <cpq-multi-list-box-with-recursion (applyPermissionsChanged)="applyPermissions = $event" [hasSelectedChildrenTooltipText]="hasSelectedChildrenTooltipText" [data] = 'data' [selectedItems]="selectedItems"></cpq-multi-list-box-with-recursion>
    </div>
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" [disabled]="!data.isMultiSelect && !selectedItems.length" (click)="save()">{{'Admin.Msg.Save' | translate}}</button>
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" tabindex="-1" (click)="close()">{{'Msg.Cancel' | translate}}</button>
  </div>
</div>



